export type PotentialArray<T> = T | Array <T>;
export type Reducable<T, C = {}> = T | ((input?: C) => T);
export interface ListResult<T extends Identifiable> {
    items: T[];
    nextToken: string;
}

export interface Comparable<T> {
    isRelated: (comparision: any) => boolean;
    parse: () => T;
}

export interface QueryListResult<T extends Identifiable> {
    [key: string]: ListResult<T>;
}

export interface Dictionary<T> {
    [index: string]: T;
}
export interface Identifiable {
    typedId: string;
}
export interface Parsable {
    parseAbsolute: () => any;
}

export type DataClass = Identifiable & Parsable;

export function getFirstKey(object: any) {
    let keys = Object.keys(object);
    if (Array.isArray(keys) && keys.length > 0) {
        return keys[0];
    }
    return false;
}

export function queryListResultConverter<T extends Identifiable> (
    input: QueryListResult<T>
): ListResult<T> {
    if (input) {
        let firstKey = getFirstKey(input);
        if ( firstKey !== false ) {
            return input[firstKey];
        } 
    }
    return undefined;
}

export function processPotentialArray<I, O>(
    input: PotentialArray <I>,
    processor: (value: I, index?: number, array?: I[] ) => O,
    index?: number
): PotentialArray<O> {
    if (typeof input === 'undefined') {
        return undefined;
    }
    if ((input as any).slice) {
        input = (input as any).slice();
    }
    if ( Array.isArray(input) ) {
        if (
            typeof index === 'undefined'
        ) {
            let ret = input.map(processor);
            ret.filter(o => typeof o !== 'undefined');
            return ret;
        } else if (
            index < 0 ||
            index > input.length
        ) {
            return undefined;
        } else {
            return processor(input[index], index, input);
        }
    } else {
        return processor(input);
    }
}

export function reduce<T>(input: Reducable<T>, ...args: any[]): T {
    if (typeof input === 'function') {
        return input( ...(args || []) );
    } else {
        return input;
    }
}

export function deepEqual(_objA: any, _objB: any, circularTracking?: any) {
    circularTracking = Array.isArray(circularTracking) || [];

    let objA = _objA && _objA.slice ? _objA.slice() : _objA;
    let objB = _objB && _objB.slice ? _objB.slice() : _objB;

    if (typeof objA !== typeof objB) {
        return false;
    }

    if (Array.isArray(objB)) {
        if (
            ! Array.isArray(objA) ||
            objA.length !== objB.length
        ) {
            return false;
        }
        return objB.every((b) => objA.some(a => deepEqual(a, b, circularTracking)));
    }

    switch (typeof objB) {
        case 'object':
            if (objA === null ||  objB === null) {
                return objA === objB;
            }
            if (circularTracking.some(o => o === objB)) {
                return true;
            }
            circularTracking.push(objB);
            
            return Object.keys(objB)
                .every(key => {
                    if ( key.substring( 0, 2 ) === '__' || key === 'prototype' ) {
                        return true;
                    }
                    return deepEqual(objA[key], objB[key], circularTracking);
                });

        case 'function':
            return true; // ignore functions

        default:
            return objA === objB;
    }

}

function itterator<I, O>(
    input:  Array<I>,
    processor: (value: I, index?: number, array?: I[] ) => O,
    resolve: any,
    output?: Array<O>, 
    currentIndex?: number
) {
    output = output || [];
    currentIndex = currentIndex || 0;
    if (input.length > currentIndex) {
        output.push(processor(input[currentIndex], currentIndex, input));
        currentIndex++;
        setTimeout(itterator, 1, input, processor, resolve, output, currentIndex);
    } else {
        resolve(output);
    }
}
export function processArrayAsync<I, O>(
    input: Array <I>,
    processor: (value: I, index?: number, array?: I[] ) => O,
): Promise<Array<O>> {
    if (typeof input === 'undefined') {
        return new Promise(res => res());
    }
    if (typeof input.slice === 'function') {
        input = input.slice();
    }
    
    return new Promise(res => itterator(input, processor, res));
}

export function ErroredPromise (reason: any) {
    return new Promise((res, rej) => rej(new Error(reason)));
}

export function CheckStores (obj: any, names: string[]) {
    let err;
    names.forEach(name => {
        if (typeof obj[name] === 'undefined') {
            err = ( err || '') + `${name} is undefined\n`;
        }
        
        // if (typeof obj[name].loading) {
        //     err = ( err || '') + `${name} is loading\n`;
        // }
    });

    return err;
}


// WEBPACK FOOTER //
// ./src/shared/utility.ts